import { render, staticRenderFns } from "./IndepentendUsersEl.vue?vue&type=template&id=c72524ee&scoped=true"
import script from "./IndepentendUsersEl.vue?vue&type=script&lang=js"
export * from "./IndepentendUsersEl.vue?vue&type=script&lang=js"
import style0 from "./IndepentendUsersEl.vue?vue&type=style&index=0&id=c72524ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72524ee",
  null
  
)

export default component.exports